// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  // A password the shop created on approval, shown once (contracts §4 `revealed`).
  secret: {
    show: 'Afficher le mot de passe',
    hide: 'Masquer le mot de passe',
    copy: 'Copier',
    copied: 'Copié',
    once: 'Affiché uniquement maintenant. Copiez-le et conservez-le en lieu sûr.',
  },
  loading: 'Chargement de la modification…',
  load_failed: "Je n'ai pas pu charger cette modification.",
  load_retry: 'Réessayer',
  // While the agent can't be reached, instead of the card's skeleton (QA119).
  load_waiting: {
    amigo: "Cette modification s'affichera ici dès qu'Amigo sera de retour. Rien n'a changé.",
    assistant: "Cette modification s'affichera ici dès que l'assistant sera de retour. Rien n'a changé.",
  },
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: "Cela a déjà été approuvé, il n'y avait donc plus rien à faire.",
  action_failed: "L'action n'a pas abouti, rien n'a donc été modifié. Réessayez dans un instant.",
  removed: 'Supprimé',
  retry: 'Réessayer',
  retry_one: 'Réessayer {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Approuvé.',
    retried: 'Nouvelle tentative effectuée.',
    rejected: 'Refusé.',
    // A restaurant skipped on a card with several restaurants (D18): its own set is rejected with this reason.
    skipped_restaurant: 'Ignoré sur la carte.',
  },
  done: {
    summary_one: 'Terminé. {{count}} modification appliquée.',
    summary_other: 'Terminé. {{count}} modifications appliquées.',
    skipped_one: "{{count}} ignorée, rien n'a changé pour elle.",
    skipped_other: "{{count}} ignorées, rien n'a changé pour elles.",
  },
  partial: {
    summary_one: '{{applied}} modifications sur {{approved}} appliquées. {{count}} non appliquées.',
    summary_other: '{{applied}} modifications sur {{approved}} appliquées. {{count}} non appliquées.',
    detail_one: "Les {{applied}} sont enregistrées. Rien n'a changé pour les {{count}} ci-dessous.",
    detail_other: "Les {{applied}} sont enregistrées. Rien n'a changé pour les {{count}} ci-dessous.",
  },
  stale: {
    summary: '{{applied}} modifications sur {{approved}} appliquées.',
    detail_one: "{{count}} a été modifiée par quelqu'un d'autre entre-temps.",
    detail_other: "{{count}} ont été modifiées par quelqu'un d'autre entre-temps.",
    reason:
      "{{name}} l'a changé en {{value}} à {{time}}, avant votre approbation, je l'ai donc laissé tel quel. Le voici à nouveau à partir de la nouvelle valeur :",
    decided_done:
      "{{name}} l'a modifié en {{value}} à {{time}}, avant votre approbation, donc je n'y ai pas touché. Sa nouvelle proposition a été approuvée sur sa propre carte.",
    decided_rejected:
      "{{name}} l'a modifié en {{value}} à {{time}}, avant votre approbation, donc je n'y ai pas touché. Sa nouvelle proposition a été refusée.",
    decided_replaced:
      "{{name}} l'a modifié en {{value}} à {{time}}, avant votre approbation, donc je n'y ai pas touché. Sa nouvelle proposition a été remplacée par une carte plus récente.",
    decided_expired:
      "{{name}} l'a modifié en {{value}} à {{time}}, avant votre approbation, donc je n'y ai pas touché. Sa nouvelle proposition a expiré.",
  },
  undo_partly_one: '{{count}} de ces éléments ne peuvent pas être annulés.',
  undo_partly_other: '{{count}} de ces éléments ne peuvent pas être annulés.',
  undone: {
    summary_one: "Annulé. La {{count}} modification est revenue à l'état précédent.",
    summary_other: "Annulé. Les {{count}} modifications sont revenues à l'état précédent.",
    detail:
      "L'annulation est également enregistrée dans le journal d'Amigo et dans Menu → Historique des modifications.",
    partly_summary: 'Partiellement annulé. {{undone}} modification(s) sur {{count}} ont été rétablies.',
    partly_changed_one: "{{count}} a été modifiée par quelqu'un d'autre depuis, elle reste donc telle quelle.",
    partly_changed_other:
      "{{count}} ont été modifiées par quelqu'un d'autre depuis, elles restent donc telles quelles.",
    partly_kept_one: "{{count}} était déjà revenu à l'état précédent.",
    partly_kept_other: "{{count}} étaient déjà revenus à l'état précédent.",
    partly_cannot_one: '{{count}} ne peut pas être annulé, comme une suppression, et reste donc tel quel.',
    partly_cannot_other: '{{count}} ne peuvent pas être annulés, comme une suppression, et restent donc tels quels.',
    partly_left_one: '{{count}} reste tel quel.',
    partly_left_other: '{{count}} restent tels quels.',
  },
  summary: {
    group_one: '{{count}} plat : {{reason}}',
    group_other: '{{count}} plats : {{reason}}',
    group_names_more_one: '{{names}} et {{count}} de plus',
    group_names_more_other: '{{names}} et {{count}} de plus',
    average: '{{amount}} par plat en moyenne',
    needs_look: 'À vérifier',
    nothing_else: "Rien d'autre ne change",
  },
  labels: {
    waiting: 'En attente',
    skip: 'Ignorer',
    unskip: "Annuler l'ignorance",
    approve_all: 'Tout approuver',
    approve_one: 'Approuver {{count}}',
    approve_other: 'Approuver {{count}}',
    approve_all_count_one: 'Tout approuver ({{count}})',
    approve_all_count_other: 'Tout approuver ({{count}})',
    approve_row: 'Approuver',
    reject: 'Ignorer',
    reject_confirm: 'Refuser',
    back: 'Retour',
    why: {
      amigo: 'Pourquoi pas ? (facultatif, Amigo le lit)',
      assistant: "Pourquoi pas ? (facultatif, l'assistant le lit)",
    },
    hint: 'Ou répondez ci-dessous pour modifier quelque chose.',
    show_all_one: 'Afficher les {{count}} modifications',
    show_all_other: 'Afficher les {{count}} modifications',
    show_less: 'Afficher moins',
    applying_one: 'Application de {{count}} modification…',
    applying_other: 'Application de {{count}} modifications…',
    high_impact: 'Impact élevé',
    done: 'Terminé',
    running: 'En cours',
    show_changes: 'Afficher les modifications',
    hide_changes: 'Masquer les modifications',
    rows: {
      skipped: 'Ignorée',
      applied: 'Appliquée',
      failed: 'Non appliquée',
      changed: 'Modifiée entre-temps',
      kept: 'Laissée telle quelle',
    },
    history: {
      amigo: "Ouvrir dans le journal d'Amigo",
      assistant: "Ouvrir dans le journal de l'assistant",
    },
    undo: 'Annuler',
    to: 'en',
    from: 'de',
    rejected: 'Refusée',
    replaced: 'Remplacée',
    expired: 'Expirée',
  },
};
